import React from 'react';

const DocsLink = props => {

  return (
    <div className="text-left my-1" >
      <a href={props.link} target="_blank">
        <u>
          View Docs <i className="webconnect webconnect-box-arrow-up-right"></i>
        </u>
      </a>
    </div>
  );
};

export default DocsLink;
